import React from 'react'
import HeroBlock from '../blocks/HeroBlock'
import Layout from '../modules/Layout'
import ArticleTripleTeaserBlock from '../blocks/ArticleTripleTeaserBlock'
import { Helmet } from 'react-helmet'
import SEO from '../modules/Seo'
import Pagination from '../modules/Pagination'
import queryString from 'query-string'
import DealerSearchBlock from '../blocks/DealerSearchBlock'

const IndexPage = ({ locale, content, name, childs, alternates }) => {
  // Optionen der Seite (oder Default)
  const per_page = parseInt(content.per_page) || 20
  const sort_by = content.sort_by || 'date'
  const sort_direction = content.sort_direction || 'desc'

  // Anzahl der Kinder
  const count = childs?.length || 0
  // Anzahl der Seiten (für Paginate)
  const pages = Math.round(count / per_page)
  // Übergebende GET-Parameter (zB. page)
  let params = {}
  if (typeof window !== 'undefined') {
    params = queryString.parse(location.search)
  }
  // Aktuelle Seite
  const current_page = parseInt(params?.page) || 1

  // 1. Ausgewählte Sortierung als "sort" mitgeben ("sort_by" per Option)
  let sortedChildren = childs?.map((child) => {
    if (child.content) {
      const content = JSON.parse(child.content)
      return {
        ...child,
        sort: content[sort_by],
      }
    } else {
      return child
    }
  })
  // Je nach Sortierungsrichtung den Wert "sort" sortieren
  if (sort_direction === 'desc') {
    sortedChildren = sortedChildren.sort((a, b) => (a.sort > b.sort ? -1 : 1))
  }
  if (sort_direction === 'asc') {
    sortedChildren = sortedChildren.sort((a, b) => (a.sort < b.sort ? -1 : 1))
  }

  // 2. Kinder reduzieren (per_page && current_page)
  let reducedSortedChildren = []
  const arrayFrom = (current_page - 1) * per_page
  const arrayTo = current_page * per_page - 1
  Object.keys(sortedChildren).forEach(function (key) {
    if (key >= arrayFrom && key <= arrayTo) {
      reducedSortedChildren.push(sortedChildren[key])
    }
  })

  return (
    <Layout locale={locale} alternates={alternates}>
      <SEO content={content} name={name} og_locale={locale} />
      <HeroBlock
        block={{
          headline: name,
          image: content.header_image,
          hero_variant_class: 'kn-product-hero',
          intro: content.intro,
        }}
      />
      <ArticleTripleTeaserBlock
        block={{}}
        data_source={reducedSortedChildren}
        hideDate={true}
      />
      {pages > 1 && <Pagination pages={pages} current_page={current_page} />}
      <DealerSearchBlock block={{}} />
    </Layout>
  )
}

export default IndexPage
